module.exports = "<i class=material-icons [ngClass]=\"{'negative' : value < 0, 'static' : value == 0}\">arrow_upward</i> ";